// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Xeojk","inner":"Footer_inner__10wXo","nextIcon":"Footer_nextIcon__jtbds","innerLeft":"Footer_innerLeft__2ksXw"};